import { inject, observer } from 'mobx-react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Highlight from 'react-highlight-words';

import { AppContextType } from '@byted-cg/linkchat-plugin';

import classes from '../constants/classes';
import { logger } from '../constants/logger';
import { prefixCls } from '../utils/style';

export interface IAutoComplete {
  keywords: string;
  appContext?: AppContextType;
  onChange: (query?: string) => void;
}
const AutoComplete = (props: IAutoComplete) => {
  const { keywords, appContext, onChange } = props;
  const lastKeywords = useRef<string>(keywords);
  const timer = useRef<number>(0);
  const [data, setData] = useState<{
    list?: any[];
    keywords?: string;
  }>({});

  const onKeywordChange = useCallback(
    async (query: string) => {
      if (!appContext?.autoComplete?.getData) return;
      try {
        const res = await appContext.autoComplete.getData(query, appContext);
        if (data && keywords === query) {
          setData({
            keywords: query,
            ...res,
          });
        }
      } catch (error) {
        appContext?.logger?.error(logger.autoComplete, {
          title: logger.autoComplete,
          info: error,
        });
        throw error;
      }
    },
    [keywords, appContext],
  );

  const getLabel = (params: any) => {
    return appContext?.autoComplete?.labelKey
      ? params[appContext?.autoComplete?.labelKey]
      : null;
  };
  const onFastClick = useCallback(
    (item: any) => async () => {
      const nextAction =
        appContext?.autoComplete?.onClick &&
        (await appContext?.autoComplete?.onClick(appContext, {
          ...item,
          robotMessageType: 14, // 固定传 14， RobotMessageType 中有定义
        }));
      if (!nextAction) {
        const label = getLabel(item);
        label && onChange(label);
        lastKeywords.current = keywords;
      } else {
        onChange();
      }
      setData({
        list: [],
      });
    },
    [onChange, appContext, keywords],
  );

  useEffect(() => {
    timer.current && clearTimeout(timer.current);
    if (lastKeywords.current === keywords) return;
    if (keywords) {
      timer.current = window.setTimeout(() => onKeywordChange(keywords), 400);
    } else {
      setData({});
    }
  }, [keywords]);

  return data.list?.length && keywords ? (
    <div
      className={prefixCls(
        {
          [`${classes.prefix}AutoComplete`]: true,
        },
        appContext?.query?.isPc,
      )}
    >
      {data.list.map((item: any, index) => (
        <li
          className="AutoCompleteLine"
          key={getLabel(item) || index}
          onClick={onFastClick(item)}
        >
          <Highlight
            highlightClassName="AutoCompleteLineLight"
            searchWords={data.keywords?.split('') || ['']}
            autoEscape={true}
            textToHighlight={getLabel(item)}
          />
        </li>
      ))}
    </div>
  ) : null;
};

export default inject(({ appContext }) => ({
  appContext,
}))(observer(AutoComplete));
